// AppRoutes.tsx
import { Suspense, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { routesConfig } from "./routesConfig";
import LoadingSpinner from "../components/loading-spinner";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { currentScreen } from "../utils/current-screen";
import { TopicSteps } from "../entities/topic";
import { joinTopic } from "../reducers/topic/actions";

interface IRoutes {
  path: string;
  component: React.FC;
  isPrivate: boolean;
  children?: IRoutes[];
}

const renderRoutes = (routes: IRoutes[], isAuthenticated: boolean) =>
  routes.map(({ path, component: Component, isPrivate, children }) => {
    if (isPrivate) {
      return (
        <Route
          key={path}
          path={path}
          element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <Component />
            </PrivateRoute>
          }
        >
          {children && renderRoutes(children, isAuthenticated)}
        </Route>
      );
    } else {
      return (
        <Route
          key={path}
          path={path}
          element={
            <PublicRoute>
              <Component />
            </PublicRoute>
          }
        >
          {children && renderRoutes(children, isAuthenticated)}
        </Route>
      );
    }
  });

const AppRoutesWrapper = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

const AppRoutes = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const topic = useSelector((state: RootState) => state.websocket.topic);
  const navigate = useNavigate();
  const prevStepRef = useRef<TopicSteps | undefined>();
  console.log("topic in routes", topic);

  useEffect(() => {
    if (topic?.step && topic.step !== prevStepRef.current) {
      prevStepRef.current = topic.step;
      currentScreen(topic.step, navigate, topic?.id?.toString());
    }
  }, [topic?.step, navigate, topic?.id]);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>{renderRoutes(routesConfig, isAuthenticated)}</Routes>
    </Suspense>
  );
};

export default AppRoutesWrapper;
